import { generateClient } from "aws-amplify/api";
import { Option } from "db/definitions";
import { bulkRetrieveOptionsByFormTemplateId } from "db/queries/optionQueries";
// @ts-ignore
import { getOptionsByFormTemplate } from "graphql/queries";
import { recordSentry } from "utils/recordSentry";

interface QueryResponse {
	data: {
		optionsByFormTemplate: {
			items: Option[];
			nextToken?: string;
		};
	};
}

/**
 * Given the formTemplate id and whether or not we're online, retrieves the options and returns them
 * @author Eric Webb <ewebb@factorearth.com>
 * @param id The formTemplate id we want to fetch the options by
 * @param online Whether or not we're online
 * @returns The array of options retrieved
 */
async function batchGetOptionsByFormTemplate(id: string, online: boolean): Promise<Option[]> {
	if (id) {
		try {
			if (online) {
				let token = undefined;
				const options: Option[] = [];
				while (token !== null) {
					const client = generateClient({ authMode: "userPool" });
					const result = (await client.graphql({
						query: getOptionsByFormTemplate,
						authMode: "userPool",
						variables: {
							formTemplate: id,
							nextToken: token,
						},
					})) as QueryResponse;
					for (const option of result.data.optionsByFormTemplate.items) {
						options.push(option);
					}
					token = result.data.optionsByFormTemplate.nextToken || null;
				}
				return options;
			} else {
				const options = await bulkRetrieveOptionsByFormTemplateId(id);
				return options;
			}
		} catch (err) {
			recordSentry({ error: err, msg: `ERROR GETTING OPTIONS ${online ? "ONLINE" : "OFFLINE"}` });
		}
	}
	return [];
}

export default batchGetOptionsByFormTemplate;
